export const penaltyReturnUrl = (value, fallback = '/penalties-management') =>
  typeof value === 'string' && /^\/penalties-management(?:[?#]|$)/.test(value) && !/[\\\r\n]/.test(value) ? value : fallback
